import { render } from "./StreamsManageAudienceLiveRoom.vue?vue&type=template&id=3fba478f"
import script from "./StreamsManageAudienceLiveRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAudienceLiveRoom.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAudienceLiveRoom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fba478f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fba478f', __exports__)) {
    api.reload('3fba478f', __exports__)
  }
  
  module.hot.accept("./StreamsManageAudienceLiveRoom.vue?vue&type=template&id=3fba478f", () => {
    api.rerender('3fba478f', render)
  })

}


export default __exports__